import EntityEditor from "../../../../../common/Tables/EntityEditor";
import { ValidatedTextInput } from "../../../../../common/inputs/ValidatedInputs";
import { usePlansData } from "../../../../../common/hooks/useRatePlansData";

const ratePlanEditorStyle = ({ theme }) => ({
    '& .MuiPaper-root': {
        width: '80%',
        maxWidth: '500px'
    }
});

const emptyRatePlan = {
    name: '',
    description: ''
};

const RatePlanEditor = ({ propertyId, onSuccess, onClose, editedRatePlan, existingRatePlans, onError }) => {
    const { createPlan, updatePlan } = usePlansData(propertyId);

    let defaultRatePlan = editedRatePlan || emptyRatePlan;
    const isEditing = !!editedRatePlan;

    const submitRatePlan = (ratePlan) => {
        const submit = isEditing ? updatePlan : createPlan;

        return submit({
            ...ratePlan
        });
    }

    const title = isEditing ? `Editing Rate Plan: ${editedRatePlan.name}` : "Creating a new Rate Plan";

    const EditorContent = (props) => {
        const { entity, onChange, disabled, entityChanged } = props;
        const ratePlan = entity;

        return <>
            <ValidatedTextInput
                margin="dense"
                id="name"
                label="Name"
                type="text"
                fullWidth
                required
                unique={{ existingValues: existingRatePlans.map(ratePlan => ratePlan.name).filter(name => !isEditing ? true : name !== editedRatePlan.name) }}
                onChange={onChange}
                disabled={disabled}
                value={ratePlan.name}
                disableError={!entityChanged}
            />
            <ValidatedTextInput
                margin="dense"
                id="description"
                label="Description"
                type="text"
                fullWidth
                multiline
                rows="2"
                onChange={onChange}
                disabled={disabled}
                value={ratePlan.description}
            />
        </>
    };

    return <EntityEditor
        dialogProps={{ sx: ratePlanEditorStyle }}
        title={title}
        defaultEntity={defaultRatePlan}
        entityName='Rate Plan'
        submitAction={submitRatePlan}
        editing={isEditing}
        onClose={onClose}
        onSuccess={onSuccess}
        EditorContent={EditorContent}
        onError={onError}
    />
}

export default RatePlanEditor;